import * as React from 'react'

import { Box } from '@factorialco/deprecated-design-system'
import { TimeoffRootPageEmployeeDataFragment } from 'generated/resources/graphql'

import { observer } from 'mobx-react'

import Leaves from 'modules/timeoff/components/Leaves'

interface Props {
  employeeData: TimeoffRootPageEmployeeDataFragment
  hasManualAdjustmentOptions: boolean
}

const TimeOffCard = ({
  employeeData,
  hasManualAdjustmentOptions,
  children,
}: React.PropsWithChildren<Props>) => {
  return (
    <Box width="full" flexGrow>
      <Leaves employeeData={employeeData} hasManualAdjustmentOptions={hasManualAdjustmentOptions} />
      {children}
    </Box>
  )
}

// Set displayName for better debugging in React DevTools and error messages
TimeOffCard.displayName = 'TimeOffCard'

export default observer(TimeOffCard)
